/**
 * Finance P1 (audit M6): api.customer_ledger returns LOST_BOTTLES and DIFFERENCE lines plus differencePaise and reconciled.
 * This only reads what the API returned; it never computes money.
 */
export interface LedgerGapFields { differencePaise?: number | null; reconciled?: boolean | null }

/** True when the statement carries a gap the office has not matched yet (differencePaise is not 0, or reconciled is false). */
export function hasLedgerGap(l: LedgerGapFields | null | undefined): boolean {
  if (!l) return false;
  return Number(l.differencePaise ?? 0) !== 0 || l.reconciled === false;
}

/** The warning wording; `fmt` is the page's own paise-to-rupees formatter. */
export function ledgerGapText(l: LedgerGapFields, fmt: (paise: number) => string): string {
  return `Not yet matched: ${fmt(Math.abs(Number(l.differencePaise ?? 0)))} — the office checks this before the bill is sent`;
}
